import { createContext, type Dispatch } from "react";
import type { Audience, Sort } from "@/hooks/useFilters";

type ContextType = {
	audience?: Audience;
	setAudience: Dispatch<Audience | undefined>;
	handleQuery: (query: string) => void;
	inputQuery?: string;
	query?: string;
	sort: Sort;
	setSort: Dispatch<Sort>;
};

export const AppContext = createContext<ContextType>({
	audience: undefined,
	inputQuery: undefined,
	query: undefined,
	sort: "a-z",
} as ContextType);
